import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supportAssistantService } from '@/services/support-assistant.service';
import type { ScopeType } from '@/types/support-assistant';

export function useAssistantSessions(page = 1, limit = 20) {
  const queryClient = useQueryClient();

  const list = useQuery({
    queryKey: ['assistant-sessions', page, limit],
    queryFn: () => supportAssistantService.listSessions(page, limit),
  });

  const createSession = useMutation({
    mutationFn: (scope?: { scopeType?: ScopeType; scopeId?: string }) =>
      supportAssistantService.createSession(scope),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['assistant-sessions'] });
    },
  });

  return { list, createSession };
}
